import React, { useEffect, useState } from "react";
import { Upload } from "antd";
import { CloseOutlined, PictureOutlined } from "@ant-design/icons";

export type UploadLogoBoxProps = {
  fileList?: any[];
  onChange?: (v: any) => void;
  /** When set (e.g. in edit mode), show this URL as preview when no new file is selected */
  initialImageUrl?: string;
  /** Called when user removes the initial image */
  onClearInitial?: () => void;
};

export const UploadLogoBox: React.FC<UploadLogoBoxProps> = ({
  fileList = [],
  onChange,
  initialImageUrl,
  onClearInitial,
}) => {
  const hasFile =
    fileList && fileList.length > 0 && fileList[0]?.originFileObj;
  const file = hasFile ? fileList[0].originFileObj : null;
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);
  const showInitial = !hasFile && initialImageUrl;

  useEffect(() => {
    if (!file) {
      setPreviewUrl(null);
      return;
    }
    const url = URL.createObjectURL(file);
    setPreviewUrl(url);
    return () => URL.revokeObjectURL(url);
  }, [file]);

  const handleRemove = () => {
    onChange?.([]);
    if (showInitial) onClearInitial?.();
  };

  return (
    <div className="add-mart-upload-box">
      {!hasFile && !showInitial ? (
        <Upload
          accept="image/*"
          showUploadList={false}
          beforeUpload={(uploadFile) => {
            onChange?.([
              {
                uid: "-1",
                name: uploadFile.name,
                status: "done",
                originFileObj: uploadFile,
              },
            ]);
            return false;
          }}
        >
          <div className="add-mart-upload-placeholder">
            <PictureOutlined className="add-mart-upload-icon" />
            <span className="add-mart-upload-text">Upload Logo</span>
          </div>
        </Upload>
      ) : (
        <div className="add-mart-upload-preview">
          {(previewUrl || (showInitial && initialImageUrl)) && (
            <img
              src={previewUrl || initialImageUrl}
              alt="Logo"
              className="add-mart-upload-preview-img"
            />
          )}
          <button
            type="button"
            className="add-mart-upload-remove"
            onClick={handleRemove}
            aria-label="Remove and upload another"
          >
            <CloseOutlined />
          </button>
        </div>
      )}
    </div>
  );
};

export default UploadLogoBox;

